import logo from "./logo.png";
import "./App.css";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>Best store to find your desired apps</p>
        <a
          className="App-link"
          href="https://play.google.com/store/apps/developer?id=MofDevApp"
          target="_blank"
          rel="noopener noreferrer"
        >
          Visit Now!
        </a>
      </header>
    </div>
  );
}

export default App;
